<template>
  <div>
    <nd-drag-new :default-x="defaultX" :default-y="defaultY" v-if="maoShow">
      <div class="mao" @click="showMao">
        <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation" class="mao-img"/>
        <div class="mao-content">
          <p v-html="supendedCatData.desc"></p>
        </div>
      </div>
    </nd-drag-new>
    <van-popup
      v-model="maoDialog"
      round
      position="bottom"
      class="popup"
    >
      <div class="popup-top">
        <p class="popup-top-content">{{maoData.titleMain}}<span class="pl30">借款<span class="red">少还{{maoData.svipCouponDiscountPrice}}</span>元</span></p>
        <img src="./images/btn_close@2x.png" class="popup-top-img" @click="close"/>
      </div>
      <p class="popup-content">{{maoData.notice}}</p>
      <div class="popup-main">
        <div v-for="(item,index) in bannerList" :key="index" class="popup-item">
          <img class="popup-item-img" :src="item.imageUrl"/>
          <p class="popup-item-title" v-html="item.desc"></p>
        </div>
      </div>
      <div class="popup-foot">
        <span class="ui-bubble" v-if="maoData.endTime && (new Date(maoData.endTime).getTime() - new Date().getTime() >0)">
          <van-count-down
            :time="new Date(maoData.endTime).getTime() - new Date().getTime()"
            format="DD天HH时mm分"
          />
        </span>
        <nd-button class="popup-foot-btn" @click="judgeOrder(maoData)">优惠价 ¥{{maoData.discountPrice}}<span class="through">原价 ¥{{maoData.price}}</span></nd-button>
        <p class="popup-foot-content">开通即同意<span @click="routerToVipProtocol" class="blue">《会员用户协议》</span></p>
      </div>
    </van-popup>
    <nd-dialog
      v-model="payDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <pay-dialog @close="payDialog=false" @jumpMiddle="jumpMiddle" :payStatusInfo="payStatusInfo"/>
    </nd-dialog>
    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="showWithdraw"
      :footer="false"
      closeBtn
      class="dialog"
    >
      <div class="huang-guan"/>
      <div class="dialog-top">
        <p class="success">成功开通SVIP</p>
        <p class="ji-huo">以下权益已激活</p>
      </div>
      <div class="dialog-center">
        <div class="dialog-center-left">
          <img src="./images/icaon_tixian_01@2x.png"/>
          <p>{{ssvip.discountRateDesc}}</p>
        </div>
        <div class="dialog-center-right">
          <img src="./images/icaon_tixian_02@2x.png"/>
          <p>{{ssvip.discountAmountDesc}}</p>
        </div>
      </div>
      <div :class="['dialog-bottom',{'mb50':isShow}]">
        <nd-button class="dialog-white" @click="jumpVip('fuli')" v-if="isShow">查看福利</nd-button>
        <nd-button class="dialog-white" @click="showWithdraw=false" v-else>继续还款</nd-button>
        <nd-button class="dialog-red" @click="jumpWithDraw">{{isShow?'立即提现':'再借再省'}}</nd-button>
      </div>
      <p @click="jumpVip('fuli')" v-if="!isShow" class="cha-kan mb50">查看福利 ></p>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import dataGif from './data.json'
import Lottie from 'vue-lottie'
import { getKey } from '../../assets/utils'
import payDialog from './payDialog.vue'
import NdDragNew from '@/components/nd-drag-new'
import qs from 'qs'

export default {
  data () {
    return {
      showGif: { animationData: dataGif },
      supendedCatData: {}, // 悬浮猫数据
      maoData: {},
      maoDialog: false,
      payDialog: false,
      payStatusInfo: {},
      ssvip: {}, // ssvip返回的弹窗数据
      showWithdraw: false,
      maoShow: false
    }
  },
  components: {
    'lottie': Lottie,
    'pay-dialog': payDialog,
    NdDragNew
  },
  async  created () {
    if (window.location.href.includes('token') || window.location.href.includes('purchaseSuccessSVIP=success')) {
      const res = await this.memberInfo()
      let { memberGoodsGroupCd } = res.data || {}
      if (res.success) {
        // 如果不是会员 跳前置页
        if (memberGoodsGroupCd === 'SVIP') {
          this.$report({
            id: 10282,
            args: {
            }
          })
          this.showWithdraw = true
          this.loanAmountPageX()
        }
      }
    }
    this.suspendedCatX()
  },
  props: {
    // 拖曳的初始位置
    defaultX: {
      type: String,
      default: ''
    },
    defaultY: {
      type: String,
      default: ''
    },
    amount: {
      type: [Number, String],
      default: 0
    },
    source: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    point: {
      type: Number,
      default: 0
    },
    // 如果type是withdraw，则调用接口需要多加两个参数（目前只有提现页面才有）
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    bannerList () {
      return this.maoData.bannerList || []
    },
    isShow () {
      return window.location.href.includes('/withdraw')
    }
  },
  watch: {
    amount () {
      this.suspendedCatX()
    },
    showWithdraw (bool) {
      if (!bool) {
        let url = window.location.href.replace(/[&]*token=[^&]*&?/g, '')
        url = url.replace(/[&]*purchaseSuccessSVIP=[^&]*&?/g, '')
        history.pushState({ url: url }, '', url)
      }
    }
  },
  methods: {
    ...mapActions('withdraw', [
      'suspendedCat',
      'buySvipPopup',
      'loanAmountPage'
    ]),
    ...mapActions('vip', [
      'orderList',
      'memberInfo'
    ]),
    // 跳转到提现
    jumpWithDraw () {
      if (window.location.href.includes('/withdraw/index')) {
        this.showWithdraw = false
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    jumpVip (data) {
      this.showWithdraw = false
      this.$report({
        id: 10274,
        args: {
          status: 'banner'
        }
      })
      const { couponSerialNos, couponType } = this.$route.query || {}
      let url = `/vip/index?target=svip&purchaseSVIP=${data}`
      couponSerialNos && (url += `&couponSerialNos=${couponSerialNos}`)
      couponType && (url += `&couponType=${couponType}`)
      this.$router.push(url)
    },
    // 获取banner数据
    async  loanAmountPageX () {
      const response = await this.loanAmountPage()
      if (response.success) {
        this.ssvip = response.data || {}
      }
    },
    // 关闭
    close () {
      this.maoDialog = false
    },
    // 弹窗
    async showMao () {
      const response = await this.buySvipPopup({ amount: this.amount })
      if (response.success && response.data) {
        this.maoData = response.data.popup || {}
        this.maoDialog = true
      }
    },
    handleAnimation (anim) {
      console.log('handleAnimation')
      this.anim = anim
    },
    // - 我要提现页面-悬浮猫
    async suspendedCatX () {
      if (this.amount || ['repayment'].includes(this.source)) {
        const params = {
          amount: this.amount || 0
        }
        if (this.type === 'withdraw') {
          Object.assign(params, {
            svipProcessNode: 'TMD_CAT',
            svipPosition: 'APPLY_AMOUNT'
          })
        }
        let response = await this.suspendedCat(params)
        if (response.success) {
          const { suspendedCat } = response.data || {}
          if (suspendedCat) {
            this.$nextTick(() => {
              this.$report({
                id: this.point,
                args: {
                  visible: 1,
                  status: this.supendedCatData.desc
                }
              })
            })
            this.maoShow = true
          }
          this.supendedCatData = suspendedCat || {}
        }
      } else {
        this.maoShow = false
        this.$report({
          id: this.point,
          args: {
            visible: 0,
            status: this.supendedCatData.desc
          }
        })
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.close()
      this.$router.push('/protocol/vip')
    },
    // 是否有已存在订单
    async judgeOrder (obj) {
      this.$report({
        id: 10275,
        args: {
          status: 'gou_mai',
          step: this.status
        }
      })
      this.close()
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        let payStatusInfo = res.data || {}
        if (
          payStatusInfo &&
          payStatusInfo.payStatus &&
          payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.payStatusInfo = payStatusInfo || {}
          this.payDialog = true
        } else {
          this.jumpMiddle(obj)
        }
      }
    },
    // 跳转到收银台
    jumpMiddle (modeOfPayment, payStatusInfo) {
      let discountPriceValue = ''
      let mode = {}
      let goods = ''
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount, goodsCd } = this.payStatusInfo || payStatusInfo || {}
        discountPriceValue = originalAmount
        goods = goodsCd
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.dialog = false
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd } = this.maoData || {}
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = {
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goods || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.status,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: {
      //       host,
      //       gid,
      //       token,
      //       device,
      //       modeType: modeOfPayment,
      //       discountPrice: discountPriceValue || discountPrice,
      //       memberType: goods || memberGoodsCd,
      //       memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
      //       status: this.status,
      //       ...mode
      //     }
      //   }
      // )
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.pl30{
    padding-left:30px;
}
.mao{
        // position:relative;
        // top:0px;
        // left:480px;
        width:240px;
        .mao-content{
            width: 250px;
            background: #FDF1D6;
            border-radius: 20px;
            padding:12px 20px 12px 17px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8C4A00;
            line-height: 33px;
        }
        .mao-img{
            display: block;
            width:130px !important;
            height:130px !important;
            margin:0 0 0 100px !important;
        }
    }
.popup{
      background: #FAFAFA;
      .through{
            text-decoration: line-through;
            margin-left:14px;
            font-size: 28px;
        }
    .popup-top{
        padding:50px 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .red{
            color:#FF4633
        }
        &-content{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
        }
        &-img{
            width:32px;
            height:32px;
        }
    }
    &-content{
        padding:5px 30px 0 30px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
    }
    &-main{
        padding:0 30px;
        margin-top:40px;
        display: flex;
        justify-content:space-between;
        .popup-item{
            width: 220px;
            padding:29px 5px 18px;
            background: #FFFFFF;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align:center;
            &-img{
                width:64px;
                height:64px;
            }
            &-title{
                text-align:left;
                margin-top:21px;
                padding:0 10px;
            }
        }
    }
    &-foot{
        margin-top:20px;
        padding-top:20px;
        width: 750px;
        height: 230px;
        background: #FFFFFF;
        box-shadow: 0px -10px 20px 0px rgba(0, 0, 0, 0.05);
        position:relative;
        /deep/ .van-count-down{
            position:absolute;
            top:17px;
            right:120px;
            padding:6px 14px;
            background: linear-gradient(90deg, #FF5F34 0%, #FF3333 100%);
            border-radius: 20px 20px 20px 0px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFD8BC;
            line-height: 28px;
            display: flex;
            align-items:center;
            justify-content:center;
        }
        &-btn{
            width: 670px;
            height: 94px;
            margin:auto;
            background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
            border-radius: 47px;
            font-size: 36px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
        }
        &-content{
            margin-top:25px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            text-align: center;
        }
        .blue{
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8EB2D8;
            line-height: 33px;
        }
    }
  }
  .dialog{
        position: relative;
        .huang-guan{
          position: absolute;
          background: url('./images/img_0@2x.png');
          background-size:cover;
          width:420px;
          height:136px;
          top:-134px;
          left:106px;
        }
        &-top{
        width: 620px;
        height: 153px;
        background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
        border-radius: 30px;
        padding-top:40px;
        margin-top:-40px;
        text-align: center;
        .success{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .ji-huo{
            font-size: 24px;
            color: #763E12;
            padding-top:5px;
        }
        }
        &-center{
        display: flex;
        justify-content:space-between;
        width: 444px;
        margin:30px auto 0;
        &-left,&-right{
            display: flex;
            flex-direction: column;
            align-items:center;
            width: 207px;
            height: 167px;
            background: #FFF7E5;
            border-radius: 14px;
            padding-top:25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            >img{
            width:80px;
            height:80px;
            }
            >p{
            margin-top:15px;
            font-size: 24px;
            color: #763E12;
            }
        }
        }
        .cha-kan{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            margin-top:47px;
            text-align:center;
        }
        .mb50{
            margin-bottom: 50px;
        }
        &-bottom{
        display: flex;
        justify-content:space-between;
        .dialog-white,.dialog-red{
            width: 270px;
            line-height: 80px;
            height: 80px;
            margin:50px auto 0;
            border-radius: 47px;
            text-align: center;
            font-size: 30px;
        }
        .dialog-white{
                border: 1px solid #FF4633;
                color: #FF4633;
                background:white;
            }
            .dialog-red{
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                color: #FFFFFF;
            }
        }
  }
</style>